<div class="contenedor-logo-menu" [style]="{ '--background-image-url': configBloque.fondo_degradado ? configBloque.color_degradado : configBloque.color_fondo }">
  <a routerLink="/" class="main-logo" (click)="setDocTitle(constantesGlobales.siteTitle)">
    <ng-container *ngIf="constantesGlobales.navTitle">
      <span class="first-newspaper" [innerText]="constantesGlobales.navTitle"></span>
    </ng-container>
    <app-skeleton-image [src]="imagenLogo" [alt]="'logo'" [aspectRatio]="'1940 / 710'" [customClass]="'logo-main'" [lazy]="false"></app-skeleton-image>
  </a>
</div>
